import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WalletCardanoModal from "../walletsManagment/WalletCardanoModal";
import { AppContext } from "../walletsManagment/connectors";
import AV from "../../av-package";
import Header from "./Header";
import "./Header.css";
import { checkCardanoSignInMethods } from "../walletsManagment/utils";
import { createToUserProfile } from "../../actions/DataActions";
import { getAuth } from "firebase/auth";

const CardanoHeader = () => {
  const [isWalletModalOpen, setWalletModalOpen] = useState(false);
  const [wallet, setWallet] = useState(null);
  const {
    cardanoAddress,
    setCardanoAddress,
    cardanoWalletId,
    setCardanoWallet,
    setCardnaoAuthToken,
    values,
  } = useContext(AppContext);

  const navigate = useNavigate();

  useEffect(() => {
    let tokenSubscriber = null;
    if (cardanoAddress) {
      tokenSubscriber = getAuth().onIdTokenChanged(function (user) {
        if (user) {
          setCardnaoAuthToken(user?.accessToken);
        }
      });
    }

    if (cardanoAddress && cardanoWalletId) {
      AV.isConnected(cardanoWalletId).then(async (isConnected) => {
        if (isConnected) {
          checkCardanoSignInMethods(cardanoAddress, {
            onError: (err) => {
              setCardanoAddress(null);
              setCardanoWallet(null);
              setWallet(null);
            },
            sucssess: (user) => {
              createToUserProfile(user, cardanoAddress);
              setCardnaoAuthToken(user?.accessToken);
              setWallet(cardanoAddress);
            },
          });
        } else {
          setCardanoAddress(null);
          setCardanoWallet(null);
          setWallet(null);
        }
      });
    } else {
      setCardanoAddress(null);
      setCardanoWallet(null);
      setWallet(null);
    }
    return () => {
      tokenSubscriber?.();
    };
  }, [cardanoAddress]);

  const goToInventary = () => {
    navigate("/monsterzone/cardano/inventory");
  };

  const goToMap = () => {
    navigate("/monsterzone/cardano");
  };

  const openModal = () => {
    setWalletModalOpen(true);
  };

  const closeModal = () => {
    setWalletModalOpen(false);
  };
  return (
    <React.Fragment>
      <Header
        openWalletModal={openModal}
        goToInventary={goToInventary}
        account={wallet}
        showInvetory={wallet ? true : false}
        goToMap={goToMap}
      />
      <WalletCardanoModal
        modalVisibility={isWalletModalOpen}
        closeModal={closeModal}
      />
    </React.Fragment>
  );
};
export default CardanoHeader;
